import type { Environment } from '@/core/lib/env/env.context';
import { ACTUAL_ENV, valuesFromProcess } from '@/core/lib/env/env.context';
import { ApiVersions } from '@/core/lib/fetch';
import api from '@/core/lib/fetch/api';
import { DonationsUserSearchForm, UserSearchesSearchesResult } from '@/core/types/donation';

const getUrl = () => valuesFromProcess[ACTUAL_ENV as Environment]?.DONNONS_API_URL;

const donationsUserSearchQuery = {
  getDonationsUserSearch: async (token?: string) => api.get<UserSearchesSearchesResult>({ url: `${getUrl()}${ApiVersions.V1}/user/searches`, token }),
};

const mutation = {
  createDonationsUserSearch: async (title: string, token: string) =>
    api.post<null, DonationsUserSearchForm>({
      url: `${getUrl()}${ApiVersions.V1}/user/searches`,
      token,
      data: { title },
    }),
  deleteDonationSearch: async (hash: string, token: string) =>
    api.destroy({
      url: `${getUrl()}${ApiVersions.V1}/user/search/${hash}`,
      token,
      data: undefined,
    }),
};

export default { mutation, donationsUserSearchQuery };
